import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  Entretien,
  EntretienFilterOptions,
  EntretienFilters,
  EntretienListResponse,
  EntretienStatut,
} from '../models';

export interface EntretienListParams extends EntretienFilters {
  page?: number;
  limit?: number;
}

@Injectable({ providedIn: 'root' })
export class EntretienApiService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/entretiens`;

  list(params: EntretienListParams = {}): Observable<EntretienListResponse> {
    const page = params.page ?? 0;
    const limit = params.limit ?? 10;
    let httpParams = new HttpParams()
      .set('page', String(page))
      .set('limit', String(limit));

    if (params.search?.trim()) {
      httpParams = httpParams.set('search', params.search.trim());
    }
    if (params.dateFrom) {
      httpParams = httpParams.set('dateFrom', params.dateFrom);
    }
    if (params.dateTo) {
      httpParams = httpParams.set('dateTo', params.dateTo);
    }
    if (params.reponse) {
      httpParams = httpParams.set('reponse', params.reponse);
    }
    if (params.entrepriseId) {
      httpParams = httpParams.set('entrepriseId', params.entrepriseId);
    }
    if (params.apprenantId) {
      httpParams = httpParams.set('apprenantId', params.apprenantId);
    }
    if (params.conseillerIds?.length) {
      httpParams = httpParams.set('conseillerIds', params.conseillerIds.join(','));
    } else if (params.conseillerId) {
      httpParams = httpParams.set('conseillerId', params.conseillerId);
    }
    if (params.statut) {
      httpParams = httpParams.set('statut', params.statut);
    }

    return this.http.get<EntretienListResponse>(this.base, {
      params: httpParams,
    });
  }

  getById(id: string): Observable<Entretien> {
    return this.http.get<Entretien>(`${this.base}/${encodeURIComponent(id)}`);
  }

  filterOptions(): Observable<EntretienFilterOptions> {
    return this.http.get<EntretienFilterOptions>(
      `${this.base}/filters/options`,
    );
  }

  relancer(id: string): Observable<{ success: boolean; entretienId: string; sentTo: string }> {
    return this.http.post<{ success: boolean; entretienId: string; sentTo: string }>(
      `${this.base}/${encodeURIComponent(id)}/relance`,
      {},
    );
  }

  updateStatut(
    id: string,
    payload: {
      statut: EntretienStatut;
      newDate?: string;
      newHeure?: string;
      reason?: string;
    },
  ): Observable<Entretien> {
    return this.http.patch<Entretien>(
      `${this.base}/${encodeURIComponent(id)}/statut`,
      payload,
    );
  }
}
